const api = {
    userLogin: '/ware/login.action',
    loginOut: '/ware/loginout.action',
    userInfo: '/ware/user/getinfo.action',
    userPwd: '/ware/user/dopwd.action',
    userPayPwd: '/ware/user/dopaypwd.action',
    root: 'https://xiapi.roctc.com',
    khroot: 'https://www.51shopee.cn',
    testRoot: 'http://localhost:30002',
    baiduUrl:"https://www.baidu.com/s?ie=UTF-8&wd=",
    skuTemplateUrl_50_30:"http://cloudprint.cainiao.com/template/standard/415725/1",
    skuTemplateUrl_50_30_code:"http://cloudprint.cainiao.com/template/standard/431639/1"
}
export default api;